import {
  Flex,
  Text,
  Box,
  Tabs,
  TabList,
  TabPanels,
  Avatar,
  HStack,
  Tab,
  TabPanel,
  Stack,
  IconButton,
  StackDivider,
  Button,
} from "@chakra-ui/react";
import React from "react";
import { BsStarFill } from "react-icons/bs";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import Portfolio from "./Portfolio";

export default function GigDescriptionSection() {
  const [selected, setSelected] = React.useState("About This Gig");
  const tabBtnListRef = React.useRef();
  const prevSelected = () => {
    let newSelection = tabBtnList.indexOf(selected);

    return tabBtnList[
      newSelection === 0 ? tabBtnList.length - 1 : newSelection - 1
    ];
  };
  const prevClickHandler = () => {
    let indexOfPrev = tabBtnList.indexOf(selected);
    let newIndexOfPrev =
      indexOfPrev === 0 ? tabBtnList.length - 1 : indexOfPrev - 1;
    setSelected(tabBtnList[newIndexOfPrev]);
    tabBtnListRef.current.children[newIndexOfPrev].click();
  };
  const nextSelected = () => {
    let newSelection = tabBtnList.indexOf(selected);

    return tabBtnList[
      newSelection === tabBtnList.length - 1 ? 0 : newSelection + 1
    ];
  };
  const nextClickHandler = () => {
    let indexOfPrev = tabBtnList.indexOf(selected);
    let newIndexOfPrev =
      indexOfPrev === tabBtnList.length - 1 ? 0 : indexOfPrev + 1;
    setSelected(tabBtnList[newIndexOfPrev]);
    tabBtnListRef.current.children[newIndexOfPrev].click();
  };
  return (
    <Box py={10}>
      <Tabs
        variant="unstyled"
        sx={{ border: "1px solid #c5c5c5" }}
        borderRadius={10}
        overflow="hidden"
        spacing={0}
      >
        <Flex pos="relative" display={{ base: "flex", sm: "none" }} justifyContent={"center"} overflow="hidden">
          <Button
          fontSize="12px"
            _selected={{ color: "white", bg: "brand.500" }}
            bg="#f1f1f1"
            w="full"
            border="1px solid #c5c5c5"
            borderLeft={0}
            borderTop={0}
            fontWeight={500}
            sx={{ py: 4 }}
            minW="120px"
            rounded="none"
            height="full"
          >
            {prevSelected()}
          </Button>
          <Button
          fontSize="12px"
            rounded="none"
            bg="brand.500"
            color="white"
            w="full"
            border="1px solid #c5c5c5"
            borderLeft={0}
            borderTop={0}
            fontWeight={500}
            sx={{ py: 4 }}
            minW="120px"
            height="full" 
          >
            {selected}
          </Button>
          <Button
          fontSize="12px"
            bg="#f1f1f1"
            w="full"
            border="1px solid #c5c5c5"
            borderLeft={0}
            borderTop={0}
            fontWeight={500}
            sx={{ py: 4 }}
            minW="120px"
            rounded="none"
            height="full"
            
          >
            {nextSelected()}
          </Button>
          <IconButton
            pos="absolute"
            left="0"
            height="full"
            background={"none"}
            _hover={{bgGradient:"linear(to-r,rgba(241,241,241,100)20%,rgba(241,241,241,0))"}}
            borderBottom="1px"  
            rounded="none"
            borderColor="#c5c5c5"
            justifyContent="start"
            bgGradient="linear(to-r,rgba(241,241,241,100)20%,rgba(241,241,241,0))"
            w="50px"
            pr={1}
            onClick={prevClickHandler}
          >
            <AiOutlineLeft />
          </IconButton>
          <IconButton
            pos="absolute"
            right={0}
            justifyContent="end"
            m={0}
            height="full"
            background={"none"}
            _hover={{bgGradient:"linear(to-r,rgba(241,241,241,0)30%,rgba(241,241,241,100)70%)"}}

            borderBottom="1px"
            rounded="none"
            borderColor="#c5c5c5"
            bgGradient="linear(to-r,rgba(241,241,241,0)30%,rgba(241,241,241,100)70%)"
            w="50px"
            pr={1}
            onClick={nextClickHandler}
          >
            <AiOutlineRight />
          </IconButton>
        </Flex>
        <TabList
          display={{ base: "none", sm: "flex" }}
          overflowX="auto"
          ref={tabBtnListRef}
        >
          <Tab
            _selected={{ color: "white", bg: "brand.500" }}
            bg="#f1f1f1"
            w="full"
            border="1px solid #c5c5c5"
            borderLeft={0}
            borderTop={0}
            fontWeight={500}
            sx={{ py: 4 }}
            minW="160px"
          >
            About This Gig
          </Tab>
          <Tab
            _selected={{ color: "white", bg: "brand.500" }}
            bg="#f1f1f1"
            w="full"
            border="1px solid #c5c5c5"
            borderLeft={0}
            borderTop={0}
            fontWeight={500}
            sx={{ py: 4 }}
            minW="160px"
          >
            Reviews (2k)
          </Tab>
          <Tab
            _selected={{ color: "white", bg: "brand.500" }}
            bg="#f1f1f1"
            w="full"
            border="1px solid #c5c5c5"
            borderLeft={0}
            borderTop={0}
            fontWeight={500}
            borderRight={0}
            sx={{ py: 4 }}
            minW="160px"
          >
            Portfolio
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel p={0}>
            <Box
              p={{ base: 4, md: 8 }}
              color="#676767"
              fontSize={{ base: "12px", md: "22px" }}
            >
              Hi there ! Thanks for stopping by !!
              <br />
              <br />
              A Team of Talented Graphic Designer with 8+ years of experience in
              Graphic Industry, expertise as Logo Maker, You'll get creative &
              AWESOME logo design for your business.
              <br />
              <br />
              <br />
              ★ Why Us? ★
              <br />
              <br />
              Talented Logo Maker Team Fully custom made, creative, original,
              UNIQUE and AWESOME designs Professional customer support 24/7 High
              Quality work 100% money back policy if not satisfied
              <br />
              <br />
              ★ WHAT DO YOU GET? ★
              <br />
              <br />
              ✔ Highly Professional, UNIQUE &amp; High Quality designs
              <br />
              <br />
              ✔ UNLIMITED revisions until u r 100% satisfied
              <br />
              <br />
              ✔ Fast turn around time 24 to 48 hours only.
              <br />
              <br />
              ✔ 100% original &amp; unique vector design from Adobe Illustrator
              <br />
              <br />
              ✔ Vector Source Files (scalable without any quality loss) (AI,
              EPS, PDF) for the final design ✔ PROFESSIONAL Communication &
              Outstanding Customer Support ✔ Guaranteed High Quality work
              <br />
              <br />
              <br />
              If you have any question,
              <br />
              <br />
              Feel free to★ Contact Me! ★I'll be happy to help !
            </Box>
          </TabPanel>
          <TabPanel p={0}>
            <Stack divider={<StackDivider />} p={5}>
              {["1", "2", "3", "4"].map((item) => {
                return (
                  <Box py={{ base: 5, sm: 10 }} px={{ sm: 6 }} key={item}>
                    <Flex gap={{base:1,sm:4}} alignItems="center">
                      <Avatar
                        src="/images/freelancer/profiles/1.png"
                        size={{ base:"md",sm: "xl" }}
                      />
                      <Stack spacing={0}>
                        <HStack alignItems={"center"} gap={2}>
                          <Text
                            fontSize={{ base: "11px", md: "16px", xl: "19px" }}
                            fontWeight={"medium"}
                          >
                            Nath2015
                          </Text>
                          <Flex
                            color={"#ffbe5b"}
                            gap={1}
                            alignItems="center"
                            fontSize={{ base: "11px", xl: "16px" }}
                          >
                            <BsStarFill />
                            <BsStarFill />
                            <BsStarFill />
                            <BsStarFill />
                            <BsStarFill />
                            <Text>5</Text>
                          </Flex>
                        </HStack>
                        <Text
                          fontWeight={"semibold"}
                          color="gray.500"
                          fontSize={{ base: "8px",sm:"10px", md: "13px", xl: "16px" }}
                        >
                          I asked for some logos for my new publishing company
                          and I am very pleased with the results
                        </Text>
                      </Stack>
                    </Flex>
                  </Box>
                );
              })}
            </Stack>
          </TabPanel>
          {/* Portfolio panel */}
          <TabPanel p={0}>
            {/* <Stack py={20} px={10} gap={5} alignItems="center">
              <Image
                src="/images/gigImage/portfolio.png"
                maxW={{ base: "120px", md: "150px", xl: "180px" }}
              />
              <Text
                fontSize={{ base: "18px", xl: "28px" }}
                color="#8f8f8f"
                fontWeight="medium"
              >
                No Portfolio Uploaded
              </Text>
            </Stack> */}
            <Portfolio />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
}
const tabBtnList = ["About This Gig", "Reviews (2K)", "Portfolio"];
